import { Editor } from "@tinymce/tinymce-react";
import React, { useEffect, useState, createRef } from "react";
import { useParams } from "react-router";
import {
  Divider,
  Grid,
  List,
  ListItem,
  Segment,
  Header,
} from "semantic-ui-react";
import AdminContent from "../Components/AdminContent";
import CommentBoard from "../Components/CommentBoard";
import "../Css/ArticlePage.css";
import {
  deleteArticel,
  getArticleByid,
  getArticlesByTag,
  getArticleTextByid,
} from "../utils/articleFuncton";
import { AUTHOR_NAME, AUTHOR_THUMBNAIL_SRC } from "../utils/datas";
import { auth } from "../utils/firebase";
import { currentLang } from "../utils/lang";
import Collapsible from "react-collapsible";
import "../Css/Collapsible.css";
import { Helmet } from "react-helmet";
import HeadTags from "../Components/HeadTags";
import Ads from "../Components/Ads";
function ArticlePage() {
  const { aid } = useParams();
  const [articleData, setArticleData] = useState();
  const [articleText, setArticleText] = useState();
  const [isBusy, setIsBusy] = useState(true);
  const [relativeArticles, setRelativeArticles] = useState();

  let tinyEditorPlugins =
    "youtube media paste autolink autosave save directionality code visualblocks visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern noneditable help charmap emoticons autoresize";
  console.log(tinyEditorPlugins.split(" "));
  tinyEditorPlugins = tinyEditorPlugins.split(" ");

  function getRelativeArticles(tags) {
    if (tags)
      getArticlesByTag(tags).then((res) => {
        console.log(res);
        setRelativeArticles(res);
      });
  }

  useEffect(() => {
    window.onbeforeunload = null;

    //取得文章
    getArticleByid(aid).then((res) => {
      console.log(res);
      setArticleData(res.data());
      //取得相關tag文章
      getRelativeArticles(res.data().tag);

      //取得內文
      getArticleTextByid(aid).then((_text) => {
        console.log(_text);
        setArticleText(_text.data());
        setIsBusy(false);
      });
    });
  }, []);

  if (isBusy) {
    /*
    document.querySelector('meta[name="description"]').setAttribute("content", window.location);
    //document.querySelector('meta[name="url"]').setAttribute("content", window.location);
    document.querySelector('meta[property="og:description"]').setAttribute("content", "discrib_test");
    */
    document.title = articleData ? articleData.title[currentLang] : "Loading";
    return (
      <>
        Loading
        {
          <HeadTags
            metaDescription={articleData?.title[currentLang]}
            key={articleData?.tag.join(",")}
            img={articleData?.thumbnail.src}
          ></HeadTags>
        }
      </>
    );
  } else
    return (
      <>
        <div centered columns={2} className="ap__root">
          {
            <HeadTags
              title={articleData.title[currentLang]}
              metaDescription={articleData.title[currentLang]}
              key={articleData?.tag.join(",")}
              author="Lontoone"
              img={articleData?.thumbnail.src}
            ></HeadTags>
          }
          {/* 
          <Helmet>
            <meta charSet="utf-8" />
            <html lang={currentLang} amp />
            <title>{articleData.title[currentLang]}</title>
            <meta name="theme-color" content="#004ba0" data-react-helmet="true" />
            <meta name="keywords" content={articleData?.tag.join(",")} data-react-helmet="true" />
            <meta name="description" content={articleData.title[currentLang]} data-react-helmet="true" />
            <meta name="author" content="Lontoone" data-react-helmet="true"  />
            <meta name="title" property="og:title" content={articleData.title[currentLang]}  data-react-helmet="true" />
            <meta name="type" property="og:type" content="website"  data-react-helmet="true" />
            <meta name="image" property="og:image" content={articleData.thumbnail.src}  data-react-helmet="true" />
            <meta name="url" property="og:url" content={window.location}  data-react-helmet="true" />
            <meta name="description" property="og:description" content={articleData.title[currentLang]} data-react-helmet="true" />
          </Helmet> */}

          {/* 左欄-主要內容 */}
          <div className="ap__mainContent">
            {/* 文章 */}
            <Segment>
              {/* 標題欄 */}
              <div className="ap__articlTitleContainer">
                {/* 預覽圖 */}
                <div className="ap__avatorContainer">
                  <img
                    src={articleData.thumbnail.src}
                    style={{
                      width: articleData?.thumbnail?.scale,
                      height: articleData?.thumbnail?.scale,
                      top: articleData?.thumbnail?.top,
                      left: articleData?.thumbnail?.left,
                    }}
                  ></img>
                </div>
                {/* 標題內容 */}
                <div className="ap__titleBox">
                  <p className="ap__title">{articleData.title[currentLang]}</p>
                  <p className="ap__meta"> {articleData?.tag.join(",")} </p>
                  <p className="ap__meta"> {articleData?.publishDate}</p>
                </div>
              </div>

              <Divider horizontal></Divider>

              {/* 內文 */}
              <div id="editor">
                <Editor
                  apiKey="achh8lkgat7b66bdkib49hzudaze1pul809bodwrh8m7ayvt"
                  disabled={true}
                  readonly={true}
                  //initialValue={articleData.data[currentLang]?.text}
                  initialValue={articleText.text[currentLang]}
                  init={{
                    readonly: 1,
                    selector: "#editor",
                    
                    plugins: [
                      "advlist autolink lists link image charmap print preview anchor",
                      "searchreplace visualblocks code fullscreen",
                      "insertdatetime media table contextmenu paste youtube",
                      "autoresize","code","visualblocks","codesample","table",
                      ],
                    
                   /*
                    plugins: [                      
                      "paste",
                      "autolink",
                      "directionality",
                      "code",
                      "visualblocks",
                      "visualchars",
                      "fullscreen",
                      "image",
                      "link",
                      "media",
                      "codesample",
                      "table",
                      "charmap",
                      "hr",                      
                      "pagebreak",
                      "nonbreaking",
                      "anchor",
                      "toc",
                      "insertdatetime",
                      "advlist",
                      "lists",
                      "wordcount",
                      "imagetools",
                      "textpattern",
                      "noneditable",
                      "help",
                      "charmap",
                      "emoticons",
                      "autoresize",
                      "media",
                      //"youtube",
                    ]*/
                    toolbar: false,
                    menubar: false,
                    extended_valid_elements:
                      "+iframe[src|width|height|name|align|class]",
                  }}
                ></Editor>
              </div>
            </Segment>
            <Segment>
              {/* 留言 */}
              <Header>留言板</Header>
              <CommentBoard aid={aid}></CommentBoard>
            </Segment>
          </div>

          {/* 右欄-資訊與其他 */}
          <div className="ap__infoBoxContainer">
            <div className="ap__infoBox">
              {/* 作者連結 */}
              <Segment>
                <div
                  className="ap__authorBox"
                  onClick={() => {
                    window.location.href = "/";
                  }}
                >
                  <img src={AUTHOR_THUMBNAIL_SRC}></img>
                  <p> {AUTHOR_NAME}</p>
                </div>
                {/* 編輯文章按鈕 */}
                <AdminContent>
                  <button
                    className="small ui button"
                    onClick={() => {
                      window.location.replace("/edit/" + aid);
                    }}
                  >
                    編輯
                  </button>
                  <button
                    className="small red ui button"
                    onClick={() => {
                      if (window.confirm("確定刪除?") == true) {
                        deleteArticel(aid).then(() => {
                          window.alert("刪除完成");
                          window.location = "/";
                        });
                      }
                    }}
                  >
                    刪除
                  </button>
                </AdminContent>

                {/* 其他按鈕 */}

                {/* Like Coin */}
                <iframe
                  data-v-b66e9a5a=""
                  src={
                    "https://button.like.co/in/embed/lontoone/button?referrer=" +
                    window.location.href
                  }
                  frameborder="0"
                  class="lc-margin-top-64 lc-margin-bottom-32 lc-mobile"
                ></iframe>
                {/* 推薦 */}
              </Segment>

              {/* 相關tag的文章 */}
              <div className="ap__sideListContainer">
                <h1>相關</h1>
                <Divider></Divider>
                <List>
                  {relativeArticles?.docs?.map((doc) => {
                    var _data = doc.data();
                    console.log(_data);
                    return (
                      <ListItem className="ap__relevantListItem">
                        <a href={"/article/" + doc.id}>
                          {_data.title[currentLang]}
                        </a>
                      </ListItem>
                    );
                  })}
                </List>
              </div>

              {/* 廣告 
              <Ads/>
              <Ads/>
              <Ads/>
              <Ads/>*/}
            </div>
          </div>
        </div>
      </>
    );
}

export default ArticlePage;
